import http from '@/assets/js/interceptor';
// 审批相关操作
export function actionOpApi (data) {
  return http.post('/bpm/actionOp', data, { domainType: 'bpmApi' });
}
// 审批列表
export function approvalList (data) {
  return http.post('/instApply/selectApproveTask', data, { domainType: 'bpmApi' });
}
// 审批详情
export function instApplyDetailApi (instApplyId) {
  return http.get(`/bpm/instApplyDetail/${instApplyId}`, { domainType: 'bpmApi' });
}
export function checkFormValuUnique(data) {
  return http.post('/bpm/checkFormValUnique', data, { domainType: 'bpmApi' });
}
